import { useState } from "react";
import { Card, CardBody, Collapse } from "reactstrap";
import { Image, LI, UL } from "../../../../../AbstractElements";
import { LatestPhotosTitle } from "../../../../../Constants/Constants";
import { dynamicImage, dynamicNumber } from "../../../../../Utils";
import HeaderWithIcon from "../HeaderWithIcon";

const LatestPhotos = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card>
      <HeaderWithIcon Heading={LatestPhotosTitle} isOpen={isOpen} setIsOpen={setIsOpen}/>
      <Collapse isOpen={isOpen}>
      <CardBody className="photos filter-cards-view">
        <UL className="text-center simple-list flex-row">
          {dynamicNumber(8).map((data, index) => (
            <LI key={index}>
              <div className="latest-post">
                <Image className="img-fluid" alt="user" src={dynamicImage(`social-app/post-${data}.png`)}/>
              </div>
            </LI>
          ))}
        </UL>
      </CardBody>
    </Collapse>
    </Card>
  );
};

export default LatestPhotos;
